var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 235,
    viewBox: "0 0 283 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M131.911 235C196.709 235 249.242 182.495 249.242 117.5C249.242 52.5049 196.709 0 131.911 0C67.1129 0 14.5801 52.5049 14.5801 117.5C14.5801 182.495 67.1129 235 131.911 235Z",
    fill: "#BED0EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47982 87.431C10.0585 87.431 12.9596 84.5314 12.9596 80.9546C12.9596 77.3778 10.0585 74.4782 6.47982 74.4782C2.90111 74.4782 0 77.3778 0 80.9546C0 84.5314 2.90111 87.431 6.47982 87.431Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.8 54.1907H39.8281C35.6267 54.1907 31.9346 57.886 31.9346 62.0909V193.59C31.9346 197.795 35.6267 196.266 39.8281 196.266H230.291C234.492 196.266 238.184 197.795 238.184 193.59V62.0909C238.694 57.886 235.002 54.1907 230.8 54.1907Z",
    fill: "url(#paint0_linear_30042_251931)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.757 188.876V193.08C262.757 197.795 258.555 202 253.845 202H16.912C12.2014 202 8 197.795 8 193.08V188.876H262.757Z",
    fill: "url(#paint1_linear_30042_251931)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.759 188.876V190.405C159.759 193.08 157.722 195.629 154.539 195.629H115.708C113.035 195.629 110.488 193.59 110.488 190.405V188.876H159.759Z",
    fill: "#E9EFF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_30042_251931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.905 71.3928V175.624C215.65 179.956 212.212 183.524 207.756 183.524H53.4509C48.8676 183.524 45.3027 179.956 45.3027 175.624V71.3928C45.3027 67.0604 48.8676 63.4926 53.4509 63.4926H207.884C212.467 63.4926 215.905 67.0604 215.905 71.3928Z",
    fill: "url(#paint2_linear_30042_251931)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5958 75.47C56.1236 75.47 57.3968 74.1958 57.3968 72.6668C57.3968 71.1377 56.1236 69.8635 54.5958 69.8635C53.0681 69.8635 51.7949 71.1377 51.7949 72.6668C51.7949 74.1958 53.0681 75.47 54.5958 75.47Z",
    fill: "#D6DCE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8732 75.47C64.401 75.47 65.6741 74.1958 65.6741 72.6668C65.6741 71.1377 64.401 69.8635 62.8732 69.8635C61.3454 69.8635 60.0723 71.1377 60.0723 72.6668C60.0723 74.1958 61.3454 75.47 62.8732 75.47Z",
    fill: "#D6DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4035 75.47C72.9312 75.47 74.2044 74.1958 74.2044 72.6668C74.2044 71.1377 72.9312 69.8635 71.4035 69.8635C69.8757 69.8635 68.6025 71.1377 68.6025 72.6668C68.6025 74.1958 69.8757 75.47 71.4035 75.47Z",
    fill: "#F1F3F9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_30042_251931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.475 53.9357V158.167C233.475 158.294 233.475 158.549 233.475 158.676C233.093 162.881 229.655 166.067 225.454 166.067H71.0212C66.4379 166.067 62.873 162.499 62.873 158.167V53.9357C62.873 49.6033 66.4379 46.0355 71.0212 46.0355H225.454C230.037 46.0355 233.475 49.4759 233.475 53.9357Z",
    fill: "url(#paint3_linear_30042_251931)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1662 58.0129C73.6939 58.0129 74.9671 56.7387 74.9671 55.2097C74.9671 53.6806 73.6939 52.4064 72.1662 52.4064C70.6384 52.4064 69.3652 53.6806 69.3652 55.2097C69.3652 56.7387 70.6384 58.0129 72.1662 58.0129Z",
    fill: "#D6DCE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4435 58.0129C81.9713 58.0129 83.2444 56.7387 83.2444 55.2097C83.2444 53.6806 81.9713 52.4064 80.4435 52.4064C78.9157 52.4064 77.6426 53.6806 77.6426 55.2097C77.6426 56.7387 78.9157 58.0129 80.4435 58.0129Z",
    fill: "#D6DCE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9718 58.0129C90.4996 58.0129 91.7728 56.7387 91.7728 55.2097C91.7728 53.6806 90.4996 52.4064 88.9718 52.4064C87.444 52.4064 86.1709 53.6806 86.1709 55.2097C86.1709 56.7387 87.444 58.0129 88.9718 58.0129Z",
    fill: "#F1F3F9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_30042_251931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.552 143.131C251.297 147.463 247.86 151.031 243.404 151.031H89.0983C84.515 151.031 80.9502 147.463 80.9502 143.131V38.9001C80.9502 34.5678 84.515 31 89.0983 31H243.531C248.115 31 251.679 34.5678 251.679 38.9001V143.131H251.552Z",
    fill: "url(#paint4_linear_30042_251931)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2453 43.1048C91.773 43.1048 93.0462 41.8306 93.0462 40.3016C93.0462 38.7725 91.773 37.3709 90.2453 37.3709C88.7175 37.3709 87.4443 38.6451 87.4443 40.1741C87.4443 41.7032 88.7175 43.1048 90.2453 43.1048Z",
    fill: "#AAB2C5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5206 43.1048C100.048 43.1048 101.322 41.8306 101.322 40.3016C101.322 38.7725 100.048 37.3709 98.5206 37.3709C96.9929 37.3709 95.7197 38.6451 95.7197 40.1741C95.7197 41.7032 96.9929 43.1048 98.5206 43.1048Z",
    fill: "#AAB2C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.051 43.1048C108.579 43.1048 109.852 41.8306 109.852 40.3016C109.852 38.7725 108.579 37.3709 107.051 37.3709C105.523 37.3709 104.25 38.6451 104.25 40.1741C104.25 41.7032 105.396 43.1048 107.051 43.1048Z",
    fill: "#AAB2C5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.44 78.0193C155.44 81.3326 152.757 84.0178 149.447 84.0178C146.138 84.0178 143.454 81.3326 143.454 78.0193C143.454 74.706 146.138 72.0208 149.447 72.0208C152.757 72.0208 155.44 74.706 155.44 78.0193Z",
    fill: "#AAB2C5",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.506 78.0193C186.506 81.3326 183.822 84.0178 180.513 84.0178C177.203 84.0178 174.52 81.3326 174.52 78.0193C174.52 74.706 177.203 72.0208 180.513 72.0208C183.822 72.0208 186.506 74.706 186.506 78.0193Z",
    fill: "#AAB2C5",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.601 111.403H151.356C147.027 111.403 144.608 106.561 147.154 102.993C149.064 100.317 151.483 98.1512 154.284 96.4947C157.467 94.7108 161.159 93.6915 164.978 93.6915C169.562 93.6915 173.763 95.0931 177.328 97.5141C179.492 99.0432 181.402 100.827 182.93 102.993C185.349 106.561 182.93 111.403 178.601 111.403Z",
    fill: "#D6DCE8",
    stroke: "#D6DCE8",
    strokeWidth: 1.7035,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.527 111.403H155.557C155.43 111.149 155.43 110.894 155.557 110.639C156.958 106.689 160.65 103.886 165.106 103.886C169.562 103.886 173.254 106.689 174.655 110.639C174.655 110.894 174.655 111.149 174.527 111.403Z",
    fill: "#AAB2C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.328 98.7888V99.8082C177.328 100.573 176.691 101.082 176.055 101.082H155.684C154.92 101.082 154.411 100.445 154.411 99.8082V97.7695C157.594 95.9856 161.286 94.9662 165.106 94.9662C169.562 94.9662 173.763 96.3678 177.328 98.7888Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.491 76.0996C117.491 78.6523 115.511 80.6945 113.035 80.6945C110.56 80.6945 108.579 78.6523 108.579 76.0996C108.579 74.1596 111.253 68.3395 112.441 65.7868C112.639 65.2762 113.332 65.2762 113.629 65.7868C114.818 68.2374 117.491 74.0575 117.491 76.0996Z",
    fill: "#D6DCE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M275.488 52.2795C277.525 54.1908 277.78 57.3764 275.87 59.5426C273.96 61.5813 270.777 61.8361 268.613 59.9248C266.958 58.5232 264.157 51.8973 263.011 48.9666C262.757 48.4569 263.266 47.8198 263.902 47.9472C266.958 48.7117 273.833 50.7505 275.488 52.2795Z",
    fill: "#D6DCE8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M274.724 74.8331C276.252 77.2541 275.615 80.3122 273.196 81.8413C270.778 83.3703 267.722 82.7332 266.194 80.3122C265.048 78.5283 264.03 71.3927 263.648 68.2071C263.521 67.57 264.284 67.1878 264.794 67.4426C267.467 69.0991 273.578 72.9217 274.724 74.8331Z",
    fill: "#D6DCE8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.305 87.5675C107.305 90.1202 105.324 92.1623 102.849 92.1623C100.373 92.1623 98.3926 90.1202 98.3926 87.5675C98.3926 85.6274 101.066 79.8073 102.254 77.2546C102.453 76.7441 103.146 76.7441 103.443 77.2546C104.631 79.8073 107.305 85.6274 107.305 87.5675Z",
    fill: "#D6DCE8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M230.801 111.403H257.792C259.447 111.403 260.974 112.04 262.12 113.187L281.217 132.3C282.363 133.447 283 134.976 283 136.633V163.519C283 165.175 282.363 166.704 281.217 167.851L262.375 186.709C261.229 187.856 259.701 188.493 258.046 188.493H230.801C229.146 188.493 227.618 187.856 226.472 186.709L207.12 167.341C205.974 166.194 205.338 164.665 205.338 163.009V136.633C205.338 134.976 205.974 133.447 207.12 132.3L226.345 113.187C227.618 112.04 229.146 111.403 230.801 111.403Z",
    fill: "#F08922"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M248.752 126.748V139.535C248.752 140.388 248.752 141.24 248.624 142.215L247.224 151.348C247.097 152.079 246.46 152.688 245.569 152.688H242.768C242.004 152.688 241.24 152.079 241.113 151.348L239.712 142.215C239.585 141.362 239.585 140.51 239.585 139.535V126.748C239.585 125.896 240.349 125.165 241.24 125.165H247.224C247.988 125.287 248.752 125.896 248.752 126.748Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M247.224 171.929H240.986C239.967 171.929 239.076 171.037 239.076 170.018V163.774C239.076 162.755 239.967 161.863 240.986 161.863H247.224C248.243 161.863 249.134 162.755 249.134 163.774V170.018C249.134 171.037 248.243 171.929 247.224 171.929Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_30042_251931",
    x: 23.3027,
    y: 52.4926,
    width: 214.602,
    height: 164.031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30042_251931"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30042_251931",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_30042_251931",
    x: 40.873,
    y: 35.0355,
    width: 214.602,
    height: 164.031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30042_251931"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30042_251931",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_30042_251931",
    x: 58.9502,
    y: 20,
    width: 214.729,
    height: 164.031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30042_251931"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30042_251931",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30042_251931",
    x1: 135.083,
    y1: 102.756,
    x2: 135.083,
    y2: 253.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063A4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30042_251931",
    x1: 135.378,
    y1: 193.353,
    x2: 135.378,
    y2: 207.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063A4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30042_251931",
    x1: 130.548,
    y1: 60.7162,
    x2: 130.548,
    y2: 184.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30042_251931",
    x1: 148.118,
    y1: 43.2591,
    x2: 148.118,
    y2: 167.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_30042_251931",
    x1: 166.259,
    y1: 28.2236,
    x2: 166.259,
    y2: 152.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.8ca2135e52b1095a7746bbd545fa550b.svg";
export { ForwardRef as ReactComponent };